module.exports = __webpack_public_path__ + "img/emoji_16.033be640.png";